import { render, staticRenderFns } from "./PartnerOrders.vue?vue&type=template&id=0b032498&"
import script from "./PartnerOrders.vue?vue&type=script&lang=js&"
export * from "./PartnerOrders.vue?vue&type=script&lang=js&"
import style0 from "./PartnerOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports